<template>
    <div class="sidebar-pinned">
      <Navbar />
  
      <main class="admin-main">
        <!--site header begins-->
        <section class="admin-content">
          <div class="container">
            
  
            <div class="col-md-12" style="margin-top: 15px">
              <button
                type="button"
                :class="buttoncolor.formal"
                @click="showFormal"
              >
                Formal <i class="fe fe-list"></i>
              </button>
              <button
                type="button"
                :class="buttoncolor.informal"
                @click="showInformal"
              >
                Informal <i class="fe fe-grid"></i>
              </button>
            </div>
  
            <div class="" v-show="formal_S">
              <FormalSector :key="'formal-' + chartRefreshKey" />
            </div>

            <div class="" v-show="informal_S">
              <InformalSector :key="'informal-' + chartRefreshKey" />
            </div>

            <div class="col-md-12" style="margin-top: 20px">
              <EncounterbyLGA :key="'encbylga-' + chartRefreshKey" />
            </div>

            <div class="col-md-12" style="margin-top: 20px">
              <EncounterbyDiagnosis :key="'encbydx-' + chartRefreshKey" />
            </div>

            <div class="row" style="margin-top: 20px">
              <div class="col-md-12">
                <ClaimsDate :key="'claimsdate-' + chartRefreshKey" />
              </div>
              <div class="col-md-12">
                <EncountersbyDate :key="'encdate-' + chartRefreshKey" />
              </div>
              <div class="col-md-4">
                <ClaimsCategory :key="'claimscat-' + chartRefreshKey" />
              </div>
              <div class="col-md-4">
                <ReferralCategory :key="'refcat-' + chartRefreshKey" />
              </div>
              <div class="col-md-4">
                <ChangeProviderCategory :key="'chprovcat-' + chartRefreshKey" />
              </div>
            </div>
  
          </div>
          <Footer />
        </section>
      </main>
    </div>
  </template>
  
  <script>
  import Navbar from "@/views/Navbar.vue";
  import Footer from "@/views/Footer.vue";
  import InformalSector from "@/views/shis/components/InformalSector.vue";
  import FormalSector from "@/views/shis/components/FormalSector.vue";
  import EncounterbyDiagnosis from "@/views/shis/components/EncounterbyDiagnosis.vue";
  import EncounterbyLGA from "@/views/shis/components/EncounterbyLGA";
  import ClaimsDate from "@/views/shis/components/ClaimsbyDate";
  import EncountersbyDate from "@/views/shis/components/EncountersbyDate";
  import ClaimsCategory from "@/views/shis/components/ClaimStatusChart";
  import ReferralCategory from "@/views/shis/components/ReferralStatusChart";
  import ChangeProviderCategory from "@/views/shis/components/ChangeProviderStatusChart";
  
  export default {
    components: {
      EncounterbyDiagnosis,
      Navbar,
      InformalSector,
      FormalSector,
      Footer,
      ClaimsDate,
      EncountersbyDate,
      ClaimsCategory,
      ReferralCategory,
      ChangeProviderCategory,
      EncounterbyLGA,
    },
  
    data() {
      return {
        user: null,
        formal_S: true,
        informal_S: false,
        mydata: "",
        auth_user: "",
        providers: "",
        clients: "",
        total_clients: "",
        trial_date: "11/11/2025",
        claims: "",
        offlineclients: [],
        employees: "",
        plans: "",
        tpas: "",
        buttoncolor: {
          informal: "btn btn-default",
          formal: "btn btn-info",
        },
        chartRefreshKey: 0,
        chartRefreshTimer: null,
      };
    },
    beforeMount() {
      this.axios
        .get(`/api/v1/auth/user`)
        .then((response) => {
          this.auth_user = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    mounted() {
      // Every chart below fetches its own data once on mount; bumping this key
      // remounts them so they refetch, keeping the dashboard in sync with the
      // backend without needing a manual page reload.
      this.chartRefreshTimer = setInterval(() => {
        this.chartRefreshKey++;
      }, 3 * 60 * 1000);
    },
    beforeDestroy() {
      clearInterval(this.chartRefreshTimer);
    },
    computed: {
      //
    },

    methods: {
      showFormal() {
        this.formal_S = true;
        this.informal_S = false;
        this.buttoncolor.formal = "btn btn-info";
        this.buttoncolor.informal = "btn btn-default";
      },
      showInformal() {
        this.formal_S = false;
        this.informal_S = true;
        this.buttoncolor.informal = "btn btn-info";
        this.buttoncolor.formal = "btn btn-default";
      },
    },
    created() {},
  };
  </script>
  <style lang="css" scoped>
  .spacer-top {
    margin-top: 10px;
  }
  </style>
  